import React, { useCallback, useMemo, useState } from 'react';
import {
    Espin_Follow_Insert_Input,
    Espin_Profile_View_Type_Enum,
    Espin_Subscription_Status_Enum,
    GetAllProfileViewDataForPlayersDocument,
    GetAllProfileViewDataForPlayersQuery,
    GetAllProfileViewDataForPlayersQueryVariables,
    ParentFollowsDocument,
    ParentFollowsMutation,
    ParentFollowsMutationVariables,
    ParentUnfollowsDocument,
    ParentUnfollowsMutation,
    ParentUnfollowsMutationVariables,
} from '../../../generated/spin-graphql';
import { ParentChildDropdown } from '../ParentChildDropdown';
import { ProfileViews } from './ProfileViews';
import { gql } from 'urql';
import { useAppState } from 'client/providers/AppProvider';
import { useAuthenticatedMutation, useAuthenticatedQuery } from '../../../client/hooks';
import {
    GetChildProfilesDocument,
    GetChildProfilesQuery,
    GetChildProfilesQueryVariables,
} from '../../../generated/spin-graphql';
import Skeleton from 'react-loading-skeleton';

// todo - i feel like this is in the user context????
gql`
    fragment ChildData on espin_parent_profile {
        child_profiles(where: { user: { deleted_at: { _is_null: true } } }) {
            user_id
            address {
                location
            }
            spin_username
            profile_image {
                cdn_url
            }
        }
    }

    query GetChildProfiles($id: String!) {
        espin_parent_profile(where: { user_id: { _eq: $id } }) {
            ...ChildData
        }
    }
`;
type Props = {
    // playerInfo: PlayerProfileViewInfo[];
};
const backUpDate = new Date().toISOString();
export const ParentProfileViews: React.FC<Props> = () => {
    const { user } = useAppState();

    const [selectedPlayer, setSelectedPlayer] = useState(0);
    const { isReady: childProfileReady, data: childProfileData } = useAuthenticatedQuery<
        GetChildProfilesQuery,
        GetChildProfilesQueryVariables
    >({
        query: GetChildProfilesDocument,
        variables: useMemo(() => ({ id: user?.id }), [user]),
        pause: !user,
    });

    const { isReady: childPlayerDataReady, data: childPlayerData } = useAuthenticatedQuery<
        GetAllProfileViewDataForPlayersQuery,
        GetAllProfileViewDataForPlayersQueryVariables
    >(
        {
            query: GetAllProfileViewDataForPlayersDocument,
            variables: {
                userId: childProfileData?.espin_parent_profile?.[0]?.child_profiles[selectedPlayer]?.user_id,
                date: user.last_login ?? backUpDate,
            },
            pause: !childProfileReady || !!!childProfileData?.espin_parent_profile,
        },
        ['espin_profile_view', 'espin_follow'],
    );
    const [_, followParent] = useAuthenticatedMutation<ParentFollowsMutation, ParentFollowsMutationVariables>(
        ParentFollowsDocument,
    );

    const [__, unFollowParent] = useAuthenticatedMutation<ParentUnfollowsMutation, ParentUnfollowsMutationVariables>(
        ParentUnfollowsDocument,
    );

    const onUnfollow = useCallback(
        (collegeId: string) => {
            // unfollows for BOTH?
            const children = childProfileData.espin_parent_profile[0].child_profiles.map((c) => c.user_id);
            unFollowParent({ playerUserId: children, collegeId }, { additionalTypenames: ['espin_follow'] });
        },
        [childProfileData?.espin_parent_profile, unFollowParent],
    );

    const onFollow = useCallback(
        (collegeId: string) => {
            const objs: Espin_Follow_Insert_Input[] = [];
            // follow for all subbed kids
            user?.parent_profile?.child_profiles?.forEach((player) => {
                // CEH-600 Player Sub hotfix
                if (player?.user.subscription_status.is_subscribed) {
                    objs.push({
                        player_user_id: player.user_id,
                        college_id: collegeId,
                    });
                }
            });
            followParent({ input: objs }, { additionalTypenames: ['espin_follow'] });
        },
        [followParent, user?.parent_profile?.child_profiles],
    );
    const listOfFollows = useMemo(() => childPlayerData?.espin_follow.map((f) => f.college_id), [
        childPlayerData?.espin_follow,
    ]);
    if (!childProfileReady && !childPlayerDataReady) {
        return <Skeleton />;
    }

    return (
        <>
            {childProfileData?.espin_parent_profile?.[0]?.child_profiles?.length > 1 && (
                <div className="parent-dropdown-container">
                    <ParentChildDropdown
                        playerInfo={childProfileData.espin_parent_profile}
                        value={childProfileData.espin_parent_profile[0].child_profiles[selectedPlayer]}
                        onChange={(value) => setSelectedPlayer(value)}
                    />
                </div>
            )}
            {childPlayerDataReady && (
                <ProfileViews
                    listOfFollows={listOfFollows}
                    // CEH-600 - Player hotfix rollback
                    childrenSubscribed={
                        user?.parent_profile.child_profiles[selectedPlayer]?.user.subscription_status.is_subscribed
                    }
                    profileViews={childPlayerData?.espin_profile_view}
                    totalViews={childPlayerData?.espin_profile_view.length}
                    newViews={childPlayerData.espin_profile_view_aggregate.aggregate.count}
                    onFollow={onFollow}
                    onUnfollow={onUnfollow}
                />
            )}
        </>
    );
};
